import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Users, Calendar, DollarSign, Shield, ArrowRight, Check } from "lucide-react";
import dashboardImg from "@/assets/dashboard-screenshot.png";

const LandingOption1 = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section - Minimalist & Bold */}
      <section className="relative bg-gradient-hero py-32 md:py-48 px-4">
        <div className="container mx-auto max-w-5xl">
          <div className="text-center space-y-8 animate-fade-in">
            <h1 className="text-6xl md:text-8xl font-bold text-foreground leading-tight tracking-tight">
              Modern PTA
              <span className="block bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
                Management
              </span>
            </h1>
            <p className="text-2xl md:text-3xl text-muted-foreground max-w-3xl mx-auto font-light">
              Everything your school community needs, beautifully simplified
            </p>
            <div className="pt-8">
              <Link to="/auth">
                <Button size="lg" className="shadow-elevated text-xl px-12 py-8 rounded-full">
                  Get Started Free
                  <ArrowRight className="ml-2 h-6 w-6" />
                </Button>
              </Link>
              <p className="text-sm text-muted-foreground mt-6">
                No credit card required • Free 14-day trial
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Features - Clean Grid */}
      <section className="py-24 px-4 bg-card">
        <div className="container mx-auto max-w-6xl">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="space-y-4 text-center">
              <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-primary flex items-center justify-center">
                <Users className="h-8 w-8 text-primary-foreground" />
              </div>
              <h3 className="text-xl font-semibold">Member Management</h3>
              <p className="text-muted-foreground">Organize your community effortlessly</p>
            </div>
            <div className="space-y-4 text-center">
              <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-primary flex items-center justify-center">
                <Calendar className="h-8 w-8 text-primary-foreground" />
              </div>
              <h3 className="text-xl font-semibold">Event Planning</h3>
              <p className="text-muted-foreground">Coordinate events seamlessly</p>
            </div>
            <div className="space-y-4 text-center">
              <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-primary flex items-center justify-center">
                <DollarSign className="h-8 w-8 text-primary-foreground" />
              </div>
              <h3 className="text-xl font-semibold">Fundraising</h3>
              <p className="text-muted-foreground">Track and manage donations</p>
            </div>
            <div className="space-y-4 text-center">
              <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-primary flex items-center justify-center">
                <Shield className="h-8 w-8 text-primary-foreground" />
              </div>
              <h3 className="text-xl font-semibold">Secure & Compliant</h3>
              <p className="text-muted-foreground">GDPR compliant security</p>
            </div>
          </div>
        </div>
      </section>

      {/* Visual Showcase */}
      <section className="py-24 px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="space-y-12">
            <div className="text-center space-y-4 max-w-3xl mx-auto">
              <h2 className="text-5xl font-bold text-foreground">
                One Platform, Endless Possibilities
              </h2>
              <p className="text-xl text-muted-foreground">
                Powerful tools designed specifically for PTAs
              </p>
            </div>
            <Card className="overflow-hidden shadow-elevated">
              <img src={dashboardImg} alt="PTA Hub Dashboard" className="w-full" />
            </Card>
          </div>
        </div>
      </section>

      {/* Benefits List */}
      <section className="py-24 px-4 bg-card/30">
        <div className="container mx-auto max-w-4xl">
          <div className="grid md:grid-cols-2 gap-8">
            {[
              "Save 10+ hours per week",
              "Increase parent engagement",
              "Streamline fundraising",
              "Improve transparency",
              "Secure data management",
              "Dedicated support"
            ].map((benefit, i) => (
              <div key={i} className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-primary flex items-center justify-center shrink-0">
                  <Check className="h-6 w-6 text-primary-foreground" />
                </div>
                <span className="text-xl text-foreground">{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-32 px-4 bg-gradient-hero">
        <div className="container mx-auto max-w-4xl text-center space-y-8">
          <h2 className="text-5xl md:text-6xl font-bold text-foreground">
            Ready to get started?
          </h2>
          <p className="text-2xl text-muted-foreground">
            Join hundreds of PTAs transforming their communities
          </p>
          <Link to="/auth">
            <Button size="lg" className="shadow-elevated text-xl px-12 py-8 rounded-full">
              Start Your Free Trial
              <ArrowRight className="ml-2 h-6 w-6" />
            </Button>
          </Link>
        </div>
      </section>

      {/* Label */}
      <div className="fixed top-20 right-4 bg-primary text-primary-foreground px-4 py-2 rounded-lg shadow-lg font-bold z-50">
        Option 1
      </div>
    </div>
  );
};

export default LandingOption1;
